// A different implementation of throttle using request animation frame. This can be useful for some functions because raf will
// allow the browser to reduce the amount of frames provided based on the available resources. So if the browser only provides
// 30fps your function will only be called 30 times

export default function schedule(fn) {
	let frameId = null
	let lastArgs = []

	const wrapper = (...args) => {
		lastArgs = args
		if (frameId) {
			return
		}

		frameId = requestAnimationFrame(() => {
			frameId = null
			fn(...lastArgs)
		})
	}

	wrapper.cancel = () => {
		if (!frameId) {
			return
		}

		cancelAnimationFrame(frameId)
		frameId = null
	}

	return wrapper
}
